"use client";
import Image from "next/image";
import Link from "next/link";
import Menu from "./Menu";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { usePath } from "../contexts/PathContext";
import { usePathname } from "next/navigation";

export default function StickyMenu() {
  const [openMenu, setOpenMenu] = useState(false);
  const { isMerchantPage } = usePath();
  const pathname = usePathname();
  const showMenu = pathname === "/" || pathname === "/merchant/";

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  // const appUrl = isMerchantPage
  //   ? "https://ptmclient.onelink.me/RsLJ/fqadoxdl"
  //   : "https://ptmemployee.onelink.me/lCZm/d8me72mj";
  const appleUrl = isMerchantPage
    ? "https://apps.apple.com/tw/app/%E6%B4%BE%E6%B4%BE%E5%95%86%E5%AE%B6%E7%89%88/id6739859895"
    : "https://apps.apple.com/tw/app/%E6%B4%BE%E6%B4%BE/id6739860028";
  const googleUrl = isMerchantPage
    ? "https://play.google.com/store/apps/details?id=tw.com.vibot.ptm.client&pcampaignid=web_share"
    : "https://play.google.com/store/apps/details?id=tw.com.vibot.ptm.employee&pcampaignid=web_share";

  return (
    <>
      {showMenu && (
        <nav className="bg-[#ffffffe8] py-4 sticky bottom-0 w-full z-10">
          <div className="flex justify-center items-center gap-4 px-4">
            <Link href={appleUrl} target="_blank" className="w-[150px]">
              <Image
                src="/assets/elements/applestore.png"
                width={200}
                height={200}
                priority
                alt="apple store"
              />
            </Link>
            <Link href={googleUrl} target="_blank" className="w-[150px]">
              <Image
                src="/assets/elements/googlestore.png"
                width={200}
                height={200}
                priority
                alt="google store"
              />
            </Link>
            <button
              className="sticky-menu-button"
              onClick={handleOpenMenu}
              aria-label="開啟選單"
            >
              <span className="block w-[55px]">
                <svg version="1.1" viewBox="0 0 200 200">
                  <path
                    fill="#0ab5dd"
                    d="M100,198.91C45.46,198.91,1.09,154.54,1.09,100S45.46,1.09,100,1.09s98.91,44.37,98.91,98.91-44.37,98.91-98.91,98.91ZM100,15.22C53.25,15.22,15.22,53.25,15.22,100s38.03,84.78,84.78,84.78,84.78-38.03,84.78-84.78S146.75,15.22,100,15.22Z"
                  />
                  <path
                    fill="#0ab5dd"
                    d="M41.85,50.48h5.55l9.84,22.68h.16l9.8-22.68h5.55v28.92h-4.74v-19.93h-.16l-8.51,19.93h-4.09l-8.51-19.93h-.16v19.93h-4.74v-28.92ZM78.44,50.48h20.86v4.05h-16.12v8.02h15.15v4.05h-15.15v8.75h16.81v4.05h-21.55v-28.92ZM104.42,50.48h4.74l14.3,20.86h.16v-20.86h4.78v28.92h-4.62l-14.46-21.14h-.16v21.14h-4.74v-28.92ZM134.09,50.48h4.74v18.02c0,2.51.57,4.33,1.74,5.55,1.13,1.17,3,1.78,5.55,1.78s4.37-.61,5.55-1.78c1.13-1.22,1.74-3.04,1.74-5.55v-18.02h4.74v17.94c0,3.77-1.05,6.64-3.16,8.63-2.11,1.94-5.06,2.92-8.87,2.92s-6.8-.97-8.83-2.88c-2.15-2.03-3.2-4.9-3.2-8.67v-17.94Z"
                  />
                  <path
                    fill="#0ab5dd"
                    d="M132.97,153.59h-65.94c-2.34,0-4.24-1.9-4.24-4.24s1.9-4.24,4.24-4.24h65.94c2.34,0,4.24,1.9,4.24,4.24s-1.9,4.24-4.24,4.24ZM132.97,128.86h-65.94c-2.34,0-4.24-1.9-4.24-4.24s1.9-4.24,4.24-4.24h65.94c2.34,0,4.24,1.9,4.24,4.24s-1.9,4.24-4.24,4.24ZM132.97,104.13h-65.94c-2.34,0-4.24-1.9-4.24-4.24s1.9-4.24,4.24-4.24h65.94c2.34,0,4.24,1.9,4.24,4.24s-1.9,4.24-4.24,4.24Z"
                  />
                </svg>
              </span>
            </button>
          </div>
        </nav>
      )}
      {/* 加入 mode="wait" 確保退場動畫完成後才移除元素 */}
      <AnimatePresence>
        {openMenu && <Menu onClose={setOpenMenu} />}
      </AnimatePresence>
    </>
  );
}
